'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const NewsletterCTA = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubscribed(true);
      setTimeout(() => {
        setEmail('');
        setIsSubscribed(false);
      }, 3000);
    }
  };

  return (
    <section className="mb-16">
      <div className="relative glassmorphic rounded-3xl p-8 lg:p-12 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-secondary/10"></div>
        <div className="absolute top-0 right-0 w-64 h-64 bg-primary/20 blur-3xl rounded-full"></div>
        
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 rounded-2xl bg-primary/20 flex items-center justify-center mx-auto mb-6">
            <Icon name="EnvelopeIcon" size={32} className="text-primary" />
          </div>
          
          <h2 className="text-3xl lg:text-4xl font-display font-bold text-foreground mb-4">
            Blijf op de hoogte van AI-trends
          </h2>
          
          <p className="text-lg text-muted-foreground mb-8">
            Ontvang wekelijks exclusieve inzichten, praktische tips en marktanalyses direct in uw inbox
          </p>
          
          {!isSubscribed ? (
            <form onSubmit={handleSubmit} className="max-w-xl mx-auto">
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  placeholder="uw.email@bedrijf.nl"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="flex-1 px-6 py-4 rounded-xl bg-card border border-border text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
                />
                <button
                  type="submit"
                  className="px-8 py-4 rounded-xl bg-primary text-primary-foreground font-semibold hover:bg-primary/90 transition-all duration-300 hover:shadow-premium whitespace-nowrap"
                >
                  Abonneren
                </button>
              </div>
              <p className="text-xs text-muted-foreground mt-3">
                Geen spam. Uitschrijven kan altijd. GDPR-compliant.
              </p>
            </form>
          ) : (
            <div className="flex items-center justify-center space-x-2 text-success">
              <Icon name="CheckCircleIcon" size={24} />
              <span className="text-lg font-semibold">Bedankt voor uw inschrijving!</span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default NewsletterCTA;